import { Box, Chip, MenuItem, Select, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

type OptionTypeArgs = {
  color: string
  label: string
}

interface RenderVewChipProps {
  option: OptionTypeArgs
}

const RenderViewChip: React.FC<RenderVewChipProps> = ({ option }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <Chip
        size="small"
        style={{
          backgroundColor: option.color,
          width: 14,
          height: 14,
          borderRadius: '50%',
          marginRight: 8,
        }}
      />
      <Typography variant="subtitle1">{option.label}</Typography>
    </Box>
  )
}

const ChangeBoardView = ({
  onChangeView,
  context,
  selectedView: propSelectedView,
  setSelectedView: propSetSelectedView,
}: {
  onChangeView: any
  context?: any
  selectedView?: any
  setSelectedView?: any
}) => {
  const theme = useTheme()
  const location = useLocation()

  const getViewFromPath = (path: string) => {
    const route = '/' + path.split('/')[1]
    const mapping: Record<string, string> = {
      '/nco': 'nco',
      '/projects': 'projects',
      '/seo': 'seo',
      '/mtb': 'mtb',
      '/optimizations': 'optimizations',
      '/deals': 'deals',
      '/organizations': 'organizations',
      '/contacts': 'contacts',
      '/leads': 'leads',
      '/teamtasks': 'teamtasks',
      '/campaignchecklists': 'campaignchecklists',
      '/ads': 'ads',
    }
    return mapping[route] || null
  }

  const [selectedView, setSelectedView] = useState<string | null>(() => {
    const initialFromPath = getViewFromPath(window.location.pathname)
    if (initialFromPath) return initialFromPath
    const fromStorage = JSON.parse(localStorage.getItem('boardSelectView') || 'null')
    return fromStorage
  })

  useEffect(() => {
    const pathView = getViewFromPath(location.pathname)
    if (pathView && pathView !== selectedView) {
      setSelectedView(pathView)
    }
  }, [location.pathname])

  const handleChange = event => {
    const newView = event.target.value
    if (typeof newView !== 'string') {
      console.error('Invalid view value:', newView)
      return
    }
    setSelectedView(newView)
    onChangeView(newView)
  }

  const options = [
    { label: 'NCO', value: 'nco', color: 'rgb(52, 211, 145)' },
    { label: 'Projects', value: 'projects', color: 'rgb(245, 108, 53)' },
    { label: 'Monthly Tasks', value: 'mtb', color: 'rgb(20, 119, 248)' },
    { label: 'Optimizations', value: 'optimizations', color: 'rgb(168, 202, 255)' },
    { label: 'Team Tasks', value: 'teamtasks', color: 'rgb(247, 63, 236)' },
  ]

  return (
    <Select
      value={selectedView || ''}
      onChange={handleChange}
      sx={{
        minWidth: 200,
        maxWidth: 200,
        height: 40,
        color: theme.palette.text.primary,
        bgcolor: theme.palette.background.paper,
        borderRadius: 2,
        '& .MuiSelect-select': { cursor: 'pointer' },
      }}
    >
      {options.map(option => (
        <MenuItem key={option.value} value={option.value}>
          <RenderViewChip option={option} />
        </MenuItem>
      ))}
    </Select>
  )
}

export default ChangeBoardView
